import actionCreatorFactory from "../util/redux/action-factory";
import { ReduxDispatch, ReduxState } from "./reducers";
import * as request from "../util/request";
import { env } from "../util/env";
import { reducerWithInitialState } from "util/redux/typed-reducers";
import {
    DocumentStatus,
    DocumentDto,
    DocumentationType,
} from "../util/DTOs/DocumentationsDtos";

const actionFactory = actionCreatorFactory("HypoMobiili/Documentations");

const getAllDocumentationsAction = actionFactory<
    null,
    Array<DocumentDto>,
    string
>("GET_DOCUMENTATIONS");

export function fetchDocumentationsData() {
    return async (dispatch: ReduxDispatch): Promise<Array<DocumentDto>> => {
        try {
            dispatch(getAllDocumentationsAction(null));

            const result = await request.get<Array<DocumentDto>>(
                `${env.APP_API_HOST}/api/documents`
            );
            dispatch(getAllDocumentationsAction.done(result));
            return result;
        } catch (err) {
            dispatch(getAllDocumentationsAction.failed(err));
            throw err;
        }
    };
}

export interface DocumentationsState {
    documents: Array<DocumentDto>;
    loading: boolean;
}

const initialDocumentationsState: DocumentationsState = {
    documents: new Array<DocumentDto>(),
    loading: false,
};

export const DocumentationsReducer = reducerWithInitialState(
    initialDocumentationsState
)
    .case(getAllDocumentationsAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getAllDocumentationsAction.done, (state, action) => {
        return {
            ...state,
            documents: action.payload,
            loading: false,
        };
    })
    .case(getAllDocumentationsAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    });

export default DocumentationsReducer;

/**
 * Selectors
 */
export const documentationsSelector = (state: ReduxState) => {
    return state && state.documentations && state.documentations.documents;
};



// WEBPACK FOOTER //
// ./src/ducks/documentations.ts